// Shared helpers for the 4-chip client-type filter (Feb 2026 iter 88).
// The Pipeline module now exposes 4 chips: 'typsa_gg' | 'typsa_colab' |
// 'privada' | 'publica'. Non-opportunity modules (Contacts, Companies,
// Tasks, Activities) can't sub-classify a TYPSA entity as GG vs Colab
// (that flag lives on the Opportunity), so the two TYPSA chips act as
// an OR bucket for those pages: at least one active → show TYPSA items.

export const ALL_CLIENT_TYPE_KEYS = ['typsa_gg', 'typsa_colab', 'privada', 'publica'];

// entityType comes from getXxxClientType() → 'typsa' | 'privada' | 'publica' | null
// filter is the active chip list.
export const matchesClientTypeFilter = (entityType, filter) => {
  if (!entityType) return false;
  if (!filter || filter.length === 0) return false;
  if (entityType === 'typsa') return filter.includes('typsa_gg') || filter.includes('typsa_colab');
  if (entityType === 'typsa_gg' || entityType === 'typsa_colab') return filter.includes(entityType);
  return filter.includes(entityType);
};

// True when the user has NOT excluded any chip.
export const isFullClientTypeSelection = (filter) => Array.isArray(filter) && filter.length >= ALL_CLIENT_TYPE_KEYS.length;
